
const categoryFontMapping = {
  'common_pitch': 'V',
  'amusement_park': '(',
  'brewery': 'm',
  'castle': '%',
  'distributor': 'j',
  'farm': '&',
  'funicular': 'W',
  'golf_course': ')',
  'lake': 'd',
  'marina': '=',
  'museum': '*',
  'nature_park': '$',
  'outlet_center': 'e',
  'restaurant': '"',
  'ski_lift': 'i',
  'tank_station': '!',
  'thermal_bath': 'x',
  'vintner': '#',
  'water_park': '\'',
  'near_camping': '?',
};

const categoryNameMapping = {
  'common_pitch': 'Allgemeiner Stellplatz',
  'amusement_park': 'Freizeitpark',
  'brewery': 'Brauerei',
  'castle': 'Schloss/Burg',
  'distributor': 'Reisemobil-Hersteller oder Händler',
  'farm': 'Bauernhof',
  'funicular': 'Seilbahn',
  'golf_course': 'Golfplatz',
  'lake': 'Badesee',
  'marina': 'Hafen/Marina',
  'museum': 'Kultur-/Technikmuseum',
  'nature_park': 'Naturpark',
  'outlet_center': 'Outlet-Center',
  'restaurant': 'Restaurant',
  'ski_lift': 'Skilift',
  'tank_station': 'Tankstelle',
  'thermal_bath': 'Thermalbad',
  'vintner': 'Winzer/Weingut',
  'water_park': 'Freizeit-/Erlebnisbad',
  'near_camping': 'Stellplatz vor Campingplatz',
};

const Constants = {
  categoryFontMapping,
  categoryNameMapping,
};
export default Constants;
